import { useToast } from '@chakra-ui/react'
import { AxiosError, AxiosResponse } from 'axios'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { fetchAPI } from '@/lib/api'
import { useErrorHandler } from '@/lib/hooks'

import { PasswordExpirationFormInput } from '../types'

import { TOAST_CONFIG } from '@/lib/constants'
import { TWO_FACTOR } from '@/features/2fa/constants'

type Payload = {
  data: PasswordExpirationFormInput
}

export const useUpdatePasswordExpiration = () => {
  const toast = useToast()
  const queryClient = useQueryClient()
  const handleError = useErrorHandler()

  const { t: tSettings } = useTranslation('settings')

  return useMutation<AxiosResponse, AxiosError, Payload>(
    ({ data }) => {
      return fetchAPI({
        path: `/settings/password_expiration`,
        method: 'put',
        data,
      })
    },
    {
      onSuccess() {
        queryClient.invalidateQueries(TWO_FACTOR)

        toast({
          ...TOAST_CONFIG,
          description: tSettings('passwordExpiration.form.toast.success'),
        })
      },
      onError(error) {
        handleError(error)
      },
    },
  )
}
